export * from "./validationEnums";

export enum ResellerDeletedBy {
  Admin = "Admin",
  Reseller = "Reseller"
}

export enum ApiRoutesResellers {
  AllUnverifiedResellers = "admin/resellers/unverified/all",
  ResellerVerification = "admin/resellers/verification",
  Resellers = "admin/resellers/many",
  ResellersTabsCounters = "admin/resellers/counts/by-level",
  Reseller = "admin/resellers",
  ResellerLevel = "level/increase",
  ResellersFilterLimits = "admin/resellers/calculate-with-order-statistics",
  ResellerCommissions = "commissions",
  ResellerReferrals = "referrals",
  ResellerReferralOrders = "orders",
  Restore = "restore"
}

export enum ResellersFilterVerificationValues {
  All = "All",
  Verified = "Verified",
  Unverified = "Female"
}

export enum ResellersFilterDeleteStatusValues {
  Active = "Active",
  Deleted = "Deleted",
  All = "All"
}

export enum ResellersFilterGenderValues {
  All = "All",
  MALE = "Male",
  FEMALE = "Female"
}

export enum ResellerVerificationStatus {
  NotSubmitted = "NotSubmitted",
  Pending = "Pending",
  Rejected = "Rejected",
  Verified = "Verified"
}

/** Status of an influencer promo code as returned on the reseller profile. */
export enum ResellerPromoCodeStatus {
  Active = "Active",
  Inactive = "Inactive"
}

/** Why an order pays the influencer a commission. */
export enum ResellerCommissionSource {
  /** The order was placed by one of the influencer's referrees. */
  Referral = "Referral",
  /** An existing customer paid with one of the influencer's promo codes. */
  PromoCode = "PromoCode"
}

/**
 * Payout state of a single commission row. Derived by the backend, not stored:
 * a ledger row only exists once the order is delivered or expedited.
 */
export enum ResellerCommissionStatus {
  Paid = "Paid",
  Pending = "Pending",
  /** Cancelled earning, or a cancelled/failed order. Counts as 0. */
  Void = "Void"
}

export enum ResellerCommissionsOrderBy {
  Date = "date",
  OrderAmount = "orderAmount",
  CommissionAmount = "commissionAmount"
}

export enum ResellerReferralsOrderBy {
  SignedUpAt = "signedUpAt",
  OrderCount = "orderCount",
  Revenue = "revenue",
  Commission = "commission"
}

export enum ResellerLevel {
  Buyer = "Buyer",
  IncompleteReseller = "IncompleteReseller",
  BeginnerReseller = "BeginnerReseller",
  IntermediateReseller = "IntermediateReseller",
  ConfirmedReseller = "ConfirmedReseller",
  Influencer = "Influencer"
}
